import { MustMatchRadioOptionValidatorConfig } from './must-match-radio-option-validator.config';
import { NameIsFirstAndLastValidatorConfig } from './name-is-first-and-last-validator.config';
import { SavingsBalanceValidatorConfig } from './savings-balance-validator.config';

export type CustomValidatorConfig =
  | SavingsBalanceValidatorConfig
  | MustMatchRadioOptionValidatorConfig
  | NameIsFirstAndLastValidatorConfig;

export enum CustomValidators {
  NAME_IS_FIRST_AND_LAST_VALIDATOR = 'name-is-first-and-last-validator',
  SAVINGS_BALANCE_VALIDATOR = 'savings-balance-validator',
  MUST_MATCH_RADIO_OPTION_VALIDATOR = 'must-match-radio-option-validator',
}
